import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Rocket, ArrowLeft, Mail, CheckCircle, Bot, Store, Users, Terminal } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent } from '../components/ui/card';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const featureInfo = {
  'bot-olusturucu': {
    icon: Bot,
    title: 'Bot Oluşturucu',
    description: 'Kod yazmadan kendi trading botunuzu oluşturun.',
    color: 'text-emerald-400',
    bgColor: 'bg-emerald-500/10',
  },
  'sinyal-saglayicilar': {
    icon: Users,
    title: 'Sinyal Sağlayıcılar',
    description: 'Başarılı trader\'ların sinyallerini keşfedin ve takip edin.',
    color: 'text-purple-400',
    bgColor: 'bg-purple-500/10',
  },
  'pazaryeri': {
    icon: Store,
    title: 'Sinyal Pazaryeri',
    description: 'Başarılı trader\'ların sinyallerini keşfedin ve takip edin.',
    color: 'text-purple-400',
    bgColor: 'bg-purple-500/10',
  },
  'sinyal-saglayici': {
    icon: Users,
    title: 'Sinyal Sağlayıcı Ol',
    description: 'Kendi sinyallerinizi yayınlayın ve gelir elde edin.',
    color: 'text-blue-400',
    bgColor: 'bg-blue-500/10',
  },
  'pro-terminal': {
    icon: Terminal,
    title: 'Pro Terminal',
    description: 'Gelişmiş trading arayüzü ve araçları.',
    color: 'text-amber-400',
    bgColor: 'bg-amber-500/10',
  },
};

const ComingSoonPage = () => {
  const navigate = useNavigate();
  const { feature } = useParams();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const info = featureInfo[feature] || {
    icon: Rocket,
    title: 'Bu Özellik',
    description: 'Yeni özellikler geliyor.',
    color: 'text-primary',
    bgColor: 'bg-primary/10',
  };

  const Icon = info.icon;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/waitlist`, { 
        email, 
        feature: feature || 'general' 
      });
      setSubmitted(true);
    } catch (err) {
      // Even if API fails, show success (we don't want to block UX)
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center p-4">
      <Card className="max-w-md w-full border-slate-800 bg-slate-900/50 backdrop-blur">
        <CardContent className="p-8 text-center">
          {/* Icon */}
          <div className={`w-20 h-20 ${info.bgColor} rounded-2xl flex items-center justify-center mx-auto mb-6`}>
            <Icon className={`h-10 w-10 ${info.color}`} />
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-white mb-2">
            🚀 Yakında Geliyor
          </h1>
          
          <h2 className={`text-lg font-semibold ${info.color} mb-4`}>
            {info.title}
          </h2>

          {/* Description */}
          <p className="text-slate-400 mb-6 leading-relaxed">
            Önceliğimiz: <span className="text-white">en kaliteli AI sinyallerini sunmak.</span>
            <br /><br />
            Bu özellik yakında kademeli olarak açılacaktır.
          </p>

          {/* Email Form */}
          {!submitted ? (
            <form onSubmit={handleSubmit} className="space-y-3">
              <Input
                type="email"
                placeholder="E-posta adresiniz"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-slate-800 border-slate-700 text-white"
                required
              />
              <Button 
                type="submit" 
                className="w-full bg-primary hover:bg-primary/90"
                disabled={loading}
              >
                <Mail className="h-4 w-4 mr-2" />
                {loading ? 'Kaydediliyor...' : 'Haber Al'}
              </Button>
            </form>
          ) : (
            <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-4">
              <CheckCircle className="h-8 w-8 text-emerald-400 mx-auto mb-2" />
              <p className="text-emerald-400 font-medium">Kaydınız alındı!</p>
              <p className="text-slate-400 text-sm mt-1">
                Özellik aktif olduğunda size haber vereceğiz.
              </p>
            </div>
          )}

          {/* Back Button */}
          <Button
            variant="ghost"
            onClick={() => navigate('/signals')}
            className="mt-6 text-slate-400 hover:text-white"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Sinyallere Dön
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ComingSoonPage;
